<template>
  <Card class="realtime-overview">
    <template slot="header">
      <div class="header flex align-center">
        <a class="pointer title mar-r5"> <span>实时概况</span> </a>
        <div class="pointer flex items-center" v-if="!isClick">
          <el-tooltip placement="bottom" effect="dark" :content="tooltip">
            <i class="el-icon-warning-outline gray6 f18 mar5-l"></i>
          </el-tooltip>
        </div>
      </div>
    </template>
    <ul class="ul-cls class">
      <li v-for="(item, index) in nav" :class="{ active: navIndex === index }" :key="index" @click="navChange(index)">
        {{ item }}
      </li>
    </ul>
    <div class="content" v-loading="loading">
      <div class="left">
        <template v-if="isShowChart">
          <div class="left-title">近30天趋势</div>
          <div class="left-chart" ref="chart"></div>
        </template>
        <template v-if="!isClick">
          <div class="flex height-full items-center justify-center fb f16 gray9" v-if="!salesAuthority">您暂无权限查看，请联系管理员</div>
          <div class="flex height-full items-center justify-center fb f16 gray9" v-else-if="!shopId || defaultShop.audit !== 1">
            您暂未拥有店铺或店铺未审核通过
          </div>
        </template>
      </div>

      <div class="right" v-if="navIndex === 0">
        <div class="blue text-center right-amount" v-if="isClick">
          <span class="right-amount-symbol">￥</span>
          <span class="f-arial fb right-amount-num">{{ $moneyFormat(orderMoney.sumMoney) }}</span>
        </div>
        <div class="text-center right-amount" v-else>*****</div>
        <div class="gray6 text-center right-text">累计成交额（元）</div>
        <div class="gray6 right-items" :class="`items${navIndex}`">
          <div class="item item0">
            <div class="item-amount" v-if="isClick">
              <div class="item-symbol">￥</div>
              <div class="f-arial item-num">{{ $moneyFormat(orderMoney.today) }}</div>
            </div>
            <div class="item-amount" v-else>*****</div>
            <div class="item-text">今日成交金额</div>
          </div>
          <div class="item item1">
            <div class="item-amount" v-if="isClick">
              <div class="item-symbol">￥</div>
              <div class="f-arial item-num">
                {{ $moneyFormat(orderMoney.yesterday) }}
              </div>
            </div>
            <div class="item-amount" v-else>*****</div>
            <div class="item-text">昨日成交金额</div>
          </div>
          <div class="item item2">
            <div class="item-amount" v-if="isClick">
              <div class="item-symbol">￥</div>
              <div class="f-arial item-num">{{ $moneyFormat(orderMoney.day7) }}</div>
            </div>
            <div class="item-amount" v-else>*****</div>
            <div class="item-text">近7日成交金额</div>
          </div>
          <div class="item item3">
            <div class="item-amount" v-if="isClick">
              <div class="item-symbol">￥</div>
              <div class="f-arial item-num">{{ $moneyFormat(orderMoney.day30) }}</div>
            </div>
            <div class="item-amount" v-else>*****</div>
            <div class="item-text">近30日成交金额</div>
          </div>
        </div>
      </div>
      <div class="right" v-if="navIndex === 1">
        <div class="blue text-center right-amount" v-if="isClick">
          <span class="f-arial fb right-amount-num">{{ $moneyFormat(orderNum.sumNum, 0) }}</span>
        </div>
        <div class="text-center right-amount" v-else>*****</div>
        <div class="gray6 text-center right-text">累计订单量（笔）</div>
        <div class="gray6 right-items" :class="`items${navIndex}`">
          <div class="item item0">
            <div class="item-amount">
              <div class="f-arial item-num" v-if="isClick">{{ $moneyFormat(orderNum.today, 0) }}</div>
              <div v-else>*****</div>
            </div>
            <div class="item-text">今日成交订单</div>
          </div>
          <div class="item item1">
            <div class="item-amount">
              <div class="f-arial item-num" v-if="isClick">
                {{ $moneyFormat(orderNum.yesterday, 0) }}
              </div>
              <div v-else>*****</div>
            </div>
            <div class="item-text">昨日成交订单</div>
          </div>
          <div class="item item2">
            <div class="item-amount">
              <div class="f-arial item-num" v-if="isClick">{{ $moneyFormat(orderNum.day7, 0) }}</div>
              <div v-else>*****</div>
            </div>
            <div class="item-text">近7日成交订单</div>
          </div>
          <div class="item item3">
            <div class="item-amount">
              <div class="f-arial item-num" v-if="isClick">{{ $moneyFormat(orderNum.day30, 0) }}</div>
              <div v-else>*****</div>
            </div>
            <div class="item-text">近30日成交订单</div>
          </div>
        </div>
      </div>
      <div class="right" v-if="navIndex === 2">
        <div class="blue text-center right-amount" v-if="isClick">
          <span class="f-arial fb right-amount-num">{{ $moneyFormat(orderVisitor.sumNum, 0) }}</span>
        </div>
        <div class="text-center right-amount" v-else>*****</div>
        <div class="gray6 text-center right-text">累计访客人数（人）</div>
        <div class="gray6 right-items" :class="`items${navIndex}`">
          <div class="item item0">
            <div class="item-amount">
              <div class="f-arial item-num" v-if="isClick">
                {{ $moneyFormat(orderVisitor.today, 0) }}
              </div>
              <div v-else>*****</div>
            </div>
            <div class="item-text">今日访客人数</div>
          </div>
          <div class="item item1">
            <div class="item-amount">
              <div class="f-arial item-num" v-if="isClick">
                {{ $moneyFormat(orderVisitor.yesterday, 0) }}
              </div>
              <div v-else>*****</div>
            </div>
            <div class="item-text">昨日访客人数</div>
          </div>
          <div class="item item2">
            <div class="item-amount">
              <div class="f-arial item-num" v-if="isClick">
                {{ $moneyFormat(orderVisitor.day7, 0) }}
              </div>
              <div v-else>*****</div>
            </div>
            <div class="item-text">近7日访客人数</div>
          </div>
          <div class="item item3">
            <div class="item-amount">
              <div class="f-arial item-num" v-if="isClick">
                {{ $moneyFormat(orderVisitor.day30, 0) }}
              </div>
              <div v-else>*****</div>
            </div>
            <div class="item-text">近30日访客人数</div>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
import { mapState } from "vuex";
import { addListener, removeListener } from "resize-detector/dist";
import Card from "@/components/Card";

const echarts = require("echarts/lib/echarts");
require("echarts/lib/component/tooltip");
require("echarts/lib/chart/line");

let chart = null;

export default {
  components: {
    Card,
  },

  data() {
    return {
      isClick: true,
      tooltip: "抱歉，您没有查看权限。若需要查看请联系公司管理员分配权限。",
      nav: ["交易额", "订单量", "访客量"],
      loading: true,
      navIndex: 0,
      orderNum: {},
      orderMoney: {},
      orderVisitor: {},
      shopId: "",
      isShowChart: true,
    };
  },

  computed: mapState({
    defaultShop: (state) => state.app.defaultShop,
    salesAuthority: (state) => state.app.salesAuthority,
  }),

  mounted() {
    const { cardId } = this.$route.query;
    if (!this.salesAuthority) {
      this.loading = false;
      this.isClick = false;
      this.isShowChart = false;
      window.parent.postMessage({ fn: "setCardHeight", data: { cardId, height: 470 } }, "*");
      return;
    }
    chart = echarts.init(this.$refs.chart);
    console.log("chart", chart);

    const { shopIdStr, audit } = this.defaultShop;
    this.shopId = shopIdStr || "";
    if (!shopIdStr || audit !== 1) {
      this.isClick = false;
      this.loading = false;
      this.tooltip = "抱歉，您暂未开店或店铺正在审核中,请先开店或等待店铺审成功后再试。";
      this.isShowChart = false;
      window.parent.postMessage({ fn: "setCardHeight", data: { cardId, height: 470 } }, "*");
      return;
    }

    window.parent.postMessage({ fn: "setCardHeight", data: { cardId, height: 545 } }, "*");
    // 查询商城店铺30天每天的订单金额
    this.$store
      .dispatch("trade/orderMoney", {
        shop_id: shopIdStr,
      })
      .then((data) => {
        if (data) {
          this.orderMoney = data;
          const self = this;

          const { dayNumList = [] } = data;
          chart.setOption({
            tooltip: {
              padding: 10,
              formatter({ name, value }) {
                return `<div class="gray3">交易额(${name})</div>
              <div class="f16 f-arial" style="min-width:100px;padding-top:2px;color:#358aff;">
              ${self.$moneyFormat(value)}
              </div>`;
              },
              borderRadius: 3,
              extraCssText: "box-shadow: 0 0 8px rgba(149,149,149,.13);",
              backgroundColor: "#fff",
            },
            grid: {
              top: 7,
              left: "17%",
              // right: 0,
              bottom: 47,
              containLabel: false,
            },
            xAxis: [
              {
                type: "category",
                data: dayNumList.map((item) => item.time),
                axisLine: {
                  lineStyle: {
                    color: "#dbdbdb",
                  },
                },
                axisTick: {
                  length: 8,
                },
                axisLabel: {
                  color: "#333",
                  padding: [5, 0, 0, -15],
                  fontSize: 14,
                  formatter(date) {
                    return date.substr(5, 5);
                  },
                  fontFamily: "Microsoft YaHei",
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                max(value) {
                  return value.max > 4 ? value.max : 5;
                },
                axisTick: { show: false },
                axisLine: { show: false },
                axisLabel: {
                  color: "#333",
                  margin: 29,
                  padding: [2, 0, 0, 0],
                  fontSize: 14,
                  fontFamily: "Arial",
                  formatter(value) {
                    let valueFormatter = value;
                    if (value >= 10000 && value < 10000000) {
                      valueFormatter = `${value / 10000} 万`;
                    } else if (value >= 10000000) {
                      valueFormatter = `${value / 10000000} 千万`;
                    }
                    return valueFormatter;
                  },
                },
                splitLine: {
                  lineStyle: {
                    type: "dotted",
                    color: "#e8e8e8",
                  },
                },
              },
            ],
            series: [
              {
                type: "line",
                symbol: "circle",
                symbolSize: 7.8,
                hoverAnimation: false,
                lineStyle: {
                  color: "#0080ff",
                },
                itemStyle: {
                  color: "#0080ff",
                  borderColor: "#fff",
                  borderWidth: 2,
                },
                animation: false,
                emphasis: {
                  itemStyle: {
                    borderColor: "rgba(0, 128, 255, 0.3)",
                    borderWidth: 5,
                  },
                },
                data: dayNumList.map((item) => item.sumMoney),
              },
            ],
          });
        }

        this.loading = false;
      });

    addListener(this.$refs.chart, () => {
      chart.resize();
    });
  },

  methods: {
    // 导航切换
    navChange(index) {
      this.navIndex = index;
      if (!this.isClick) {
        this.loading = false;
        return;
      }
      const { orderNum, orderMoney, orderVisitor, defaultShop } = this;
      const self = this;

      // 交易额
      if (index === 0) {
        chart.setOption({
          tooltip: {
            formatter({ name, value }) {
              return `<div class="gray3">交易额(${name})</div>
              <div class="f16 f-arial" style="min-width:100px;padding-top:2px;color:#358aff;">
              ${self.$moneyFormat(value, 0)}
              </div>`;
            },
          },
          xAxis: [
            {
              data: orderMoney.dayNumList.map((item) => item.time),
            },
          ],
          yAxis: [
            {
              minInterval: 0,
            },
          ],
          series: [
            {
              data: orderMoney.dayNumList.map((item) => item.sumMoney),
            },
          ],
        });
      }

      // 订单量
      if (index === 1) {
        if (orderNum.dayNumList) {
          chart.setOption({
            tooltip: {
              formatter({ name, value }) {
                return `<div class="gray3">订单量(${name})</div>
                  <div class="f16 f-arial" style="min-width:100px;padding-top:2px;color:#358aff;">
                  ${self.$moneyFormat(value, 0)}
                </div>`;
              },
            },
            xAxis: [
              {
                data: orderNum.dayNumList.map((item) => item.time),
              },
            ],
            yAxis: [
              {
                minInterval: 1,
              },
            ],
            series: [
              {
                data: orderNum.dayNumList.map((item) => item.num),
              },
            ],
          });
        } else {
          // 查询商城店铺30天每天的订单数量
          this.loading = true;
          this.$store
            .dispatch("trade/orderNum", {
              shop_id: defaultShop.shopIdStr,
            })
            .then((data) => {
              this.orderNum = data;
              const { dayNumList = [] } = data;
              chart.setOption({
                tooltip: {
                  formatter({ name, value }) {
                    return `<div class="gray3">订单量(${name})</div>
                  <div class="f16 f-arial" style="min-width:100px;padding-top:2px;color:#358aff;">
                  ${self.$moneyFormat(value, 0)}
                  </div>`;
                  },
                },
                xAxis: [
                  {
                    data: dayNumList.map((item) => item.time),
                  },
                ],
                yAxis: [
                  {
                    minInterval: 1,
                  },
                ],
                series: [
                  {
                    data: dayNumList.map((item) => item.num),
                  },
                ],
              });
              this.loading = false;
            });
        }
      }

      // 访客量
      if (index === 2) {
        if (orderVisitor.dayNumList) {
          chart.setOption({
            tooltip: {
              formatter({ name, value }) {
                return `<div class="gray3">访客量(${name})</div>
                  <div class="f16 f-arial" style="min-width:100px;padding-top:2px;color:#358aff;">
                  ${self.$moneyFormat(value, 0)}
                </div>`;
              },
            },
            xAxis: [
              {
                data: orderVisitor.dayNumList.map((item) => item.time),
              },
            ],
            yAxis: [
              {
                minInterval: 1,
              },
            ],
            series: [
              {
                data: orderVisitor.dayNumList.map((item) => item.num),
              },
            ],
          });
        } else {
          // 查询店铺访客数量
          this.loading = true;
          this.$store
            .dispatch("trade/visitorNum", {
              shop_id: defaultShop.shopIdStr,
            })
            .then((data) => {
              this.orderVisitor = data;
              const { dayNumList = [] } = data;
              chart.setOption({
                tooltip: {
                  formatter({ name, value }) {
                    return `<div class="gray3">访客量(${name})</div>
                  <div class="f16 f-arial" style="min-width:100px;padding-top:2px;color:#358aff;">
                  ${self.$moneyFormat(value, 0)}
                  </div>`;
                  },
                },
                xAxis: [
                  {
                    data: dayNumList.map((item) => item.time),
                  },
                ],
                yAxis: [
                  {
                    minInterval: 1,
                  },
                ],
                series: [
                  {
                    data: dayNumList.map((item) => item.num),
                  },
                ],
              });
              this.loading = false;
            });
        }
      }
    },
  },

  beforeDestroy() {
    removeListener(this.$refs.chart, () => {
      chart.resize();
    });
  },
};
</script>
